// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
// import { addCertificate, deleteCertificate, fetchAllCertificates } from "../../apis/partner"

// export const useFetchAllCertificates = (partnerId) => {
//     return useQuery({
//         queryKey: ["certificates",partnerId],
//         queryFn: () => fetchAllCertificates(partnerId),
//         onError: (error) => {
//             console.error(error);
//         },
//     })
// }

// export const useAddCertificate = (navigate) => {
//     const queryClient = useQueryClient();
//     return useMutation({
//         mutationFn: ({ partnerId, certificate }) => addCertificate(partnerId, certificate),
//         onSuccess: (newCertificate,variables) => {
//         const { partnerId } = variables;

//   queryClient.refetchQueries({queryKey:["certificates",partnerId]})

//             navigate("/dashboard/certificates", { replace: true });
//         },
//         onError: (error) => {
//             console.error('Error!', error);
//         }
//     })
// }
// export const useDeleteCertificate = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: ({ partnerId, certificateId }) =>
//       deleteCertificate(partnerId, certificateId),

//     onSuccess: (_, { partnerId, certificateId }) => {
//       console.log("Certificate Deleted!");
//       queryClient.setQueryData(["certificates", partnerId], (oldData) => {
//         if (oldData) {
//           return oldData.filter(
//             (certificate) => certificate.certificate_id !== certificateId
//           );
//         }
//         return oldData;
//       });
//     },

//     onError: (error) => {
//       console.error("Error!", error);
//     },
//   });
// };

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addCertificate,
  deleteCertificate,
  fetchAllCertificates,
  updateCertificate,
} from "../../apis/partner";
import { useDispatch } from "react-redux";
import {
  
  updateCertificateData,
} from "../../store/Partner/partnerDataSlice";


export const useFetchAllCertificates = (partnerId) => {
  return useQuery({
    queryKey: ["certificates", partnerId],
    queryFn: () => fetchAllCertificates(partnerId),
    onError: (error) => {
      console.error(error);
    },
  });
};

export const useAddCertificate = (navigate) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partnerId, certificate }) =>
      addCertificate(partnerId, certificate),
    onSuccess: (newCertificate, variables) => {
      const { partnerId } = variables;
      queryClient.refetchQueries({ queryKey: ["certificates", partnerId] });
      navigate("/dashboard/certificates", { replace: true });
    },
    onError: (error) => {
      console.error("Error!", error);
    },
  });
};

// export const useUpdateCertificate = (navigate) => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: ({ partnerId, certificateId, certificate }) =>
//       updateCertificate(partnerId, certificateId, certificate),
//     onSuccess: (_, { partnerId }) => {
//       queryClient.refetchQueries({ queryKey: ["certificates", partnerId] });
//       navigate("/dashboard/certificates", { replace: true });
//     },
//     onError: (error) => {
//       console.error("Error updating certificate:", error);
//     },
//   });
// };

export const useUpdateCertificate = (navigate) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: ({ partnerId, certificateId, certificate }) => {
      console.log("Mutation payload:", { certificateId, certificate });
      return updateCertificate(certificateId, certificate);
    },
    onSuccess: (updatedCertificate, { partnerId }) => {
      console.log("Update success:", updatedCertificate);
      queryClient.refetchQueries({ queryKey: ["certificates", partnerId] });
      dispatch(updateCertificateData(updatedCertificate)); // Update Redux store
      navigate("/dashboard/certificates", { replace: true });
    },
    onError: (error) => {
      console.error(
        "Update certificate error:",
        error.response?.data || error.message
      );
    },
  });
};

export const useDeleteCertificate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partnerId, certificateId }) =>
      deleteCertificate(partnerId, certificateId),
    onSuccess: (_, { partnerId, certificateId }) => {
      console.log("Certificate Deleted!");
      queryClient.setQueryData(["certificates", partnerId], (oldData) => {
        if (oldData) {
          return oldData.filter(
            (certificate) => certificate.certificate_id !== certificateId
          );
        }
        return oldData;
      });
    },
    onError: (error) => {
      console.error("Error!", error);
    },
  });
};
